import { ALGORITHM_TYPE, SOLAR_DELIVERY_METHOD } from '@/utils/constants.js';

/**
 * Translate from backend (solarDeliveryMethod) to frontend (algorithmType).
 * This function should match main-server src/utils/delivery-method.ts
 */
export const getAlgorithmTypeFromSolarDeliveryMethod = (method: SOLAR_DELIVERY_METHOD) => {
  switch (method) {
    case SOLAR_DELIVERY_METHOD.NET_METERING:
    case SOLAR_DELIVERY_METHOD.OPTIMISED_AND_EVEN:
    case SOLAR_DELIVERY_METHOD.UNEQUAL_ALLOCATION:
    case SOLAR_DELIVERY_METHOD.DEMAND_WEIGHTED_PRIORITY:
      return ALGORITHM_TYPE.CUSTOM_ALLOCATION;

    case SOLAR_DELIVERY_METHOD.FULLY_OPTIMISED:
      return ALGORITHM_TYPE.DEMAND_BASED_DELIVERY;

    default:
      return null;
  }
};

/**
 * Translate from frontend (algorithmType) to backend (solarDeliveryMethod).
 * @param type - The algorithm type to translate ("DEMAND_BASED_DELIVERY" or "CUSTOM_ALLOCATION")
 * @param variation - Optional variations to consider when translating.
 * @returns The solar delivery method
 */
export const getSolarDeliveryMethodFromAlgorithmType = (
  type: ALGORITHM_TYPE,
  variation?: {
    is2P?: boolean;
    isUnequalAlgorithm?: boolean;
  },
) => {
  if (variation?.is2P) {
    return SOLAR_DELIVERY_METHOD.NET_METERING;
  } else {
    if (type === ALGORITHM_TYPE.DEMAND_BASED_DELIVERY) {
      return SOLAR_DELIVERY_METHOD.FULLY_OPTIMISED;
    } else if (type === ALGORITHM_TYPE.CUSTOM_ALLOCATION) {
      return variation?.isUnequalAlgorithm
        ? SOLAR_DELIVERY_METHOD.UNEQUAL_ALLOCATION
        : SOLAR_DELIVERY_METHOD.OPTIMISED_AND_EVEN;
    }
  }
};
